var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{staticClass:"title is-2"},[_vm._v("403")]),_c('p',[_vm._v("Not Allowed to Access this Page")])])
}]

export { render, staticRenderFns }